import React from "react";
import { View } from "react-native";
import { styles } from "../style/FoundryStyle.js";
import { SCREEN_IDS } from "../components/FullComponent.js";
import QueryDetalleTiempos from "../components/Informes/ComponentQueryDetalleTiempos.js";
import { LinearGradient } from "expo-linear-gradient";
import { backgroundColor } from "../constants/Constants.js";

export default function InformeTiemposDiario({ navigation }) {
  const screenName = "DailyTimeReport";
  const currentScreenId = SCREEN_IDS.INFO_TIME_DIARIO;

  return (
    <LinearGradient colors={backgroundColor()} style={styles.containerNoColor}>
      <View style={styles.containerNoColor}>
        <View>
          <QueryDetalleTiempos />
          <View style={""}></View>
        </View>
      </View>
    </LinearGradient>
  );
}
